import * as React from 'react';

import {SingleInputModal} from 'shells/single-input-modal/single-input-modal';

import {GetSessionUser} from '../core/get-session-user';

import {authWithoutLogin} from './utils';

type Props = {
    attemptDisableMfa: (userId?: string) => void;
    setIsPromptReauthenticate: (arg1: boolean) => void;
    userId?: string;
};

export function ReauthenticateModal(props: Props) {
    const [isSavingModal, setIsSavingModal] = React.useState(false);
    const [errorMessageModal, setErrorMessageModal] = React.useState('');

    return (
        <GetSessionUser>
            {({user}) => (
                <SingleInputModal
                    requireValue={false}
                    buttonText='Turn off'
                    initialValue=''
                    title='Let’s make sure it’s you'
                    subtitle='Re-enter your password to turn off two-factor authentication'
                    placeholder='••••••'
                    isSaving={isSavingModal}
                    inputType={'password'}
                    errorMessage={errorMessageModal ? errorMessageModal : ''}
                    preventFormNesting={true}
                    onClose={() => {
                        props.setIsPromptReauthenticate(false);
                    }}
                    onSave={(pass, e) => {
                        if (e) {
                            e.preventDefault();
                        }

                        if (user && user.emailAddresses) {
                            setIsSavingModal(true);
                            // @ts-expect-error
                            setErrorMessageModal(null);

                            // @ts-expect-error
                            authWithoutLogin(pass, user.emailAddresses[0].address)
                                .then(() => {
                                    setErrorMessageModal('');
                                    setIsSavingModal(false);
                                    props.attemptDisableMfa(
                                        props.userId ? props.userId : undefined
                                    );
                                })
                                .catch(() => {
                                    setErrorMessageModal('Sorry, your password is incorrect');
                                    setIsSavingModal(false);
                                });
                        }
                    }}
                />
            )}
        </GetSessionUser>
    );
}
